import { getHybridSRVSubAppData } from './report-hybrid-srv-sub-app-data';
export const hasAccessToTab = (subAppKey, tab, gates, scopes) => {
  const tabData = getHybridSRVSubAppData(subAppKey)[tab];
  const requiredScope = tabData.scope;
  const requiredGate = tabData.gate;
  return (!requiredScope || scopes.includes(requiredScope)) && (!requiredGate || gates.includes(requiredGate));
};